import FaceTecSDK, { FaceTecSessionStatus } from "facetec-sdk";
import sessionStatusMessages from "./sessionStatusMessages";

type StatusName = keyof typeof FaceTecSessionStatus;

const statusName = (status: FaceTecSessionStatus) =>
  FaceTecSDK.FaceTecSessionStatus[status] as StatusName;

class FaceTecSessionError extends Error {
  constructor(readonly status: FaceTecSessionStatus) {
    super(sessionStatusMessages[statusName(status)]);

    // Keep `instanceof` working when compiled to ES5.
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export default FaceTecSessionError;
